export default {
  logo_text: '坐席工作台',
  sidebar_chat: '当前会话',
  sidebar_chatlog: '会话记录',
  sidebar_workorder: '我的工单',
  sidebar_evaluation: '服务评价',
  sidebar_leaveword: '访客留言',
  sidebar_setting: '个人设置',
  sidebar_overview: '任务概览',
  sidebar_workreport: '工作报表',
  sidebar_watch: '主管监控'
}
